import React, { useContext } from 'react';
import { LanguageContext } from "../languages/LanguageContext";
import { Link } from "react-router-dom";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";

const FacebookAd = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='facebook-container max-w flex gap-sm ai-c'>
            <HiOutlineArrowNarrowRight className='icon' />
            <Link to='https://www.facebook.com/aldona.biedermann'>{translations[language]["facebook"]}</Link>
        </div>
    );
};

export default FacebookAd;